import { render, staticRenderFns } from "./JobBannerSettings.vue?vue&type=template&id=46c7e338"
import script from "./JobBannerSettings.vue?vue&type=script&lang=js"
export * from "./JobBannerSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports